import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Filter from "src/components/TableFilter";
import {
  FIRST_NAME,
  LAST_NAME,
  LIMIT,
  PAGE,
  ROLES,
} from "src/constants/searchParams";
import { toNumber } from "src/utils/toNumber";
import { filters } from "./utils/filters";
import { useGetAllEmployeesQuery } from "src/api/services/employeesApi";
import EmployeesTable from "./components/EmployeesTable";
import NewMemberModal from "src/components/Modals/NewMemberModal";
import { useManageModal } from "src/hooks/useManageModal";
import AddIcon from "@mui/icons-material/Add";

const Employees = () => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const [params] = useSearchParams();
  const page = useMemo(() => toNumber(params.get(PAGE)), [params]);
  const limit = useMemo(() => toNumber(params.get(LIMIT)), [params]);

  const from = useMemo(() => {
    return page * limit;
  }, [limit, page]);

  const to = useMemo(() => {
    return from + limit - 1;
  }, [from, limit]);

  const queryParams = useMemo(() => {
    return {
      first_name: params.get(FIRST_NAME) ?? undefined,
      last_name: params.get(LAST_NAME) ?? undefined,
      role: params.get(ROLES) ?? undefined,
      from,
      to,
    };
  }, [from, params, to]);

  const { data, isFetching } = useGetAllEmployeesQuery(queryParams);

  const { users, count } = useMemo(() => {
    if (data == null) return { users: [], count: 0 };

    return { users: data.data, count: data.count };
  }, [data]);

  return (
    <>
      <Stack gap="32px">
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h4" fontWeight={600}>
            Employees
          </Typography>
          <Button startIcon={<AddIcon />} onClick={handleOpen}>
            Add New
          </Button>
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          height={60}
          alignItems="center"
        >
          <Stack
            direction="row"
            gap="16px"
            flexWrap="wrap"
            width="100%"
            alignItems="center"
          >
            {filters.map((filter) => (
              <Filter key={filter.name} current={filter} />
            ))}
          </Stack>
        </Stack>
        <Stack gap={0}>
          <Box height={4}>
            {isFetching ? <LinearProgress color="success" /> : null}
          </Box>
          <EmployeesTable employees={users} total={count} />
        </Stack>
      </Stack>
      <NewMemberModal open={open} onClose={handleClose} />
    </>
  );
};

export default Employees;
